/**
 * AppLayout -- VS Code-style shell for module workspaces.
 *
 * Layout structure:
 *
 *   HeaderBar (top bar -- logo, help, user menu)
 *   +-----------+-------------------------------+---------+
 *   | Activity  |                               | Toolbox |
 *   | Bar       |  <Outlet /> (module content)  | (right  |
 *   | (far left)|                               |  strip) |
 *   +-----------+-------------------------------+---------+
 *   StatusBar (bottom bar -- connection, version, save status)
 *
 * This layout is for the standalone browser experience only.
 * UE embedded WebViews use /embed/* routes which bypass all layouts.
 */

import { Outlet, useLocation } from 'react-router-dom'
import { HeaderBar } from '@/core/app/shell/HeaderBar'
import { ActivityBar } from '@/core/app/shell/ActivityBar'
import { StatusBar } from '@/core/app/shell/StatusBar'
import { Toolbox } from '@/core/app/shell/Toolbox'
import { ChromeOverlays } from '@/core/app/shell/ChromeOverlays'

function getModuleFromPath(pathname: string): string {
  const segment = pathname.split('/').filter(Boolean)[0]
  if (segment === 'gdbforge' || segment === 'forge') return 'forge'
  if (segment === 'oracle') return 'oracle'
  if (['hoard', 'prism', 'echo'].includes(segment || '')) return segment || 'oracle'
  return 'oracle'
}

export default function AppLayout() {
  const location = useLocation()
  const currentModule = getModuleFromPath(location.pathname)

  return (
    <div className="h-screen bg-ue-bg-darkest flex flex-col overflow-hidden">
      <HeaderBar />
      <div className="flex flex-1 min-h-0 overflow-hidden">
        <ActivityBar />
        <main className="flex-1 min-w-0 overflow-hidden">
          <Outlet />
        </main>
        <Toolbox currentModule={currentModule} />
      </div>
      <StatusBar />
      {/* Global chrome overlays (Feedback + Help) — mounted once per shell. */}
      <ChromeOverlays />
    </div>
  )
}
